import greenCream from "../img/buchete-de-vara/1green-cream.webp";
import pastelGlow from "../img/buchete-de-vara/2pastel-glow.webp";
import suunyHorizon from "../img/buchete-de-vara/3sunny-horizon.webp";
import pinkLemonade from "../img/buchete-de-vara/4pink-lemonade.webp";
import summerSerenade from "../img/buchete-de-vara/5summer-serenade.webp";
import sunsetPark from "../img/buchete-de-vara/6sunset-park.webp";
import saphireBliss from "../img/buchete-de-vara/7saphire-bliss.webp";
// import rainbowGlow from "../img/buchete-de-vara/8rainbow-glow.webp";
// import goldenGem from "../img/buchete-de-vara/9golden-gem.webp";
import blazingSummer from "../img/buchete-de-vara/10blazing-summer.webp";
import oceanBreeze from "../img/buchete-de-vara/11ocean-breeze.webp";
// import summerRomance from "../img/buchete-de-vara/12summer-romance.webp";
import lemonadeBliss from "../img/buchete-de-vara/13lemonade-bliss.webp";
// import berrySorbet from "../img/buchete-de-vara/14berry-sorbet.webp";
import nightBlue from "../img/buchete-de-vara/15night-blue.webp";
import cherryBlossom from "../img/buchete-de-vara/16cherry-blossom.webp";
import sunsetParkBlue from "../img/buchete-de-vara/17sunset-park.webp";
import citrusDelight from "../img/buchete-de-vara/18citrus-delight.webp";
import carnival from "../img/buchete-de-vara/19carnival.webp";
import tropicalParadise from "../img/buchete-de-vara/20tropical-paradise.webp";

// import blush from "../img/buchete-de-vara/22blush.webp";
import summerSkies from "../img/buchete-de-vara/23summer-skies.webp";
import limeBlooms from "../img/buchete-de-vara/24lime-blooms.webp";
import vividSunshine from "../img/buchete-de-vara/25vivid-sunshine.webp";
import daisyMeadow from "../img/buchete-de-vara/26daisy-meadow.webp";
import brightHorizons from "../img/buchete-de-vara/27bright-horizons.webp";
import scarletRadiance from "../img/buchete-de-vara/28scarlet-radiance.webp";
import blueLagoon from "../img/buchete-de-vara/29blue-lagoon.webp";
import jadeOasis from "../img/buchete-de-vara/30jade-oasis.webp";
import fiesta from "../img/buchete-de-vara/31fiesta.webp";
import sunnyPosy from "../img/buchete-de-vara/32sunny-posy.webp";
import pinkBreeze from "../img/buchete-de-vara/33pink-breeze.webp";
import lushLavender from "../img/buchete-de-vara/34lush-lavender.webp";
import wildflowerRadiance from "../img/buchete-de-vara/35wildflower-radiance.webp";
// import daydream from "../img/buchete-de-vara/36daydream.webp";
import purpleRain from "../img/buchete-de-vara/37puprle-rain.webp";
import vibrantDelight from "../img/buchete-de-vara/38vibrant-delight.webp";
import blueRiver from "../img/buchete-de-vara/39blue-river.webp";
// import summerInBlue from "../img/buchete-de-vara/40summer-in-blue.webp";
import serenityWhite from "../img/buchete-de-vara/41-serenity-white.webp";
import purplePink from "../img/buchete-de-vara/42-purple-pink.webp";
import satin from "../img/buchete/2satin.webp";
import cheer from "../img/buchete/12cheer.webp";
import luxeHarmony from "../img/cele-mai-vindute/Luxe-Harmony.webp";
import pureSerenity from "../img/buchete-premium/3pure-serenity.webp";
import hortensiaMix from "../img/buchete-premium/5hortensia-mix.webp";
// import bloomInBlue from "../img/buchete-premium/7bloom-in-blue.webp";
import eleganceInColor from "../img/buchete-premium/17elegance-in-color.webp";
import pureBeauty from "../img/buchete-premium/23pure-beauty.webp";
import grace from "../img/buchete/8grace.webp";
import hydrangeaGlow from "../img/buchete/63hydrangea-glow.webp";
import mapleKiss from "../img/buchete-premium/15maple-kiss.webp";
// import lilac from "../img/buchete/43lilac.webp";
// import colorPop from "../img/buchete/48color-pop.webp";
import pinkSplash from "../img/buchete/64pink-splash.webp";
// import euphoria from "../img/buchete/65euphoria.webp";
import timelessEmbrace from "../img/buchete/77timeless-embrace.webp";

//1151-1250
const BucheteDeVara = [
  {
    id: 1151,
    name: "Green Cream",
    price: "1700 lei",
    description:
      "Buchet format din hortensie, eustome, trandafiri, crizanteme, gipsofila și eucalipt. ",
    images: [greenCream],
  },
  {
    id: 1152,
    name: "Saphire Bliss",
    price: "1200 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri, crizanteme, eustome și eucalipt .",
    images: [saphireBliss],
  },
  {
    id: 1153,
    name: "Pastel Glow",
    price: "950 lei",
    description: "Buchet format din hortensie, eustome si gipsofila colorata. ",
    images: [pastelGlow],
  },
  {
    id: 1154,
    name: "Serenity White",
    price: "700 lei",
    description: "Buchet format din hortensie, eustome, si crizanteme.",
    images: [serenityWhite],
  },
  {
    id: 1155,
    name: "Pink Lemonade",
    price: "900 lei",
    description: "Buchet superb din hortensie, trandafiri si gipsofila.",
    images: [pinkLemonade],
  },
  {
    id: 1156,
    name: "Pure Serenity",
    price: "4000 lei",
    description:
      "Buchet elegant format din hortensii, orhidei, trandafiri, hypericum, eustome si eucalipt.",
    images: [pureSerenity],
  },
  {
    id: 1157,
    name: "Timeless Embrace",
    price: "1700 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri de tip bujor si eucalipt.",
    images: [timelessEmbrace],
  },
  {
    id: 1158,
    name: "Maple Kiss",
    price: "1600 lei",
    description:
      "Buchet catifelat format din hortensii, trandafiri Silva Pink si eucalipt.",
    images: [mapleKiss],
  },
  {
    id: 1159,
    name: "Pink Splash",
    price: "1300 lei",
    description:
      "Buchet elegant format din trandafiri Silva Pink, eustome si eucalipt.",
    images: [pinkSplash],
  },
  {
    id: 1160,
    name: "Cheer",
    price: "900 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri, crizanteme si verdeata decorativa.",
    images: [cheer],
  },
  {
    id: 1161,
    name: "Vivid Sunshine",
    price: "800 lei",
    description:
      "Buchet format din hortensie, gerbere, dianthus, crizanteme si bujori.",
    images: [vividSunshine],
  },
  {
    id: 1162,
    name: "Sunny Horizon",
    price: "2300 lei",
    description: "Buchet format din hortensie, bujori si eucalipt.",
    images: [suunyHorizon],
    // checkAvailability: true,
  },
  {
    id: 1163,
    name: "Grace",
    price: "1200 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri de tip bujor si eucalipt.",
    images: [grace],
  },
  {
    id: 1164,
    name: "Satin",
    price: "1300 lei",
    description:
      "Buchet format din hortensie, trandafiri, eustome,bujori si anthurium. ",
    images: [satin],
  },
  {
    id: 1165,
    name: "Summer Serenade",
    price: "1150 lei",
    description:
      "Buchet format din hortensie, crizanteme, gerbere, trandafiri de tip bujor si eucalipt.",
    images: [summerSerenade],
  },
  {
    id: 1166,
    name: "Sunset Park",
    price: "1600 lei",
    description:
      "Buchet elegant din hortensie, trandafiri, eustome si eucalipt.",
    images: [sunsetPark],
  },
  {
    id: 1167,
    name: "Luxe Harmony",
    price: "3450 lei",
    description:
      "Buchet elegant cu accent de culoare format din hortensii, trandafiri, crizanteme și hypericum.",
    images: [luxeHarmony],
  },
  {
    id: 1168,
    name: "Blazing Summer",
    price: "1100 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri, hipericum, eustome si gipsofila colorata.",
    images: [blazingSummer],
  },
  {
    id: 1169,
    name: "Ocean Breeze",
    price: "950 lei",
    description: "Buchet format din hortensie, eustome si gipsofila.",
    images: [oceanBreeze],
  },
  {
    id: 1170,
    name: "Lemonade Bliss",
    price: "1600 lei",
    description:
      "Buchet format din hortensie, crizanteme, trandafiri, eustome si eucalipt.",
    images: [lemonadeBliss],
  },
  {
    id: 1171,
    name: "Night Blue",
    price: "1100 lei",
    description:
      "Buchet format din hortensie, astromerii, eustome si gipsofila.",
    images: [nightBlue],
  },

  {
    id: 1172,
    name: "Cherry Blossom",
    price: "1100 lei",
    description:
      "Buchet format din mix de trandafiri, crizanteme, eustome si eucalipt.",
    images: [cherryBlossom],
  },
  {
    id: 1173,
    name: "Sunset Park Blue",
    price: "1200 lei",
    description:
      "Buchet format din hortensie, trandafiri, crizanteme, eustome si eucalipt.",
    images: [sunsetParkBlue],
  },
  {
    id: 1174,
    name: "Citrus Delight",
    price: "1500 lei",
    description:
      "Buchet format din hortensie, anturium, lilii, crizanteme, eustome si gladiole.",
    images: [citrusDelight],
    // checkAvailability: true,
  },
  {
    id: 1175,
    name: "Carnival",
    price: "1000 lei",
    description:
      "Buchet format din hortensie, trandafiri, eustome si eucalipt.",
    images: [carnival],
  },
  {
    id: 1176,
    name: "Tropical Paradise",
    price: "1000 lei",
    description:
      "Buchet format din hortensie, trandafiri, eustome, crizanteme si eucalipt.",
    images: [tropicalParadise],
  },
  {
    id: 1177,
    name: "Summer Skies",
    price: "1600 lei",
    description:
      "Buchet format din hortensii, trandafiri, eustome, gerbere, delphinium, antirinium si eucalipt.",
    images: [summerSkies],
  },

  {
    id: 1179,
    name: "Fiesta",
    price: "1200 lei",
    description:
      "Buchet format din hortensie, eustome, anthurium, trandafiri de tip bujor, antirinium, delphinium si eucalipt.",
    images: [fiesta],
  },
  {
    id: 1180,
    name: "Scarlet Radiance",
    price: "1200 lei",
    description:
      "Buchet format din hortensie, gerbere, eustome, crizanteme si trandafiri.",
    images: [scarletRadiance],
  },
  {
    id: 1181,
    name: "Elegance in Color",
    price: "2500 lei",
    description:
      "Buchet sofisticat format din hortensii, trandafiri Avalanche, trandafiri de tip bujor, matiole si gipsofila.",
    images: [eleganceInColor],
  },
  {
    id: 1182,
    name: "Lime Blooms",
    price: "1100 lei",
    description:
      "Buchet format din hortensie, trandafiri de tip bujor, trandafiri Avalanche, eustome, crizanteme si verdeata decorativa.",
    images: [limeBlooms],
    // checkAvailability: true,
  },
  {
    id: 1183,
    name: "Bright Horizons",
    price: "2000 lei",
    description:
      "Buchet format din hortensii, trandafiri, eustome, crizanteme, gerbere si eucalipt.",
    images: [brightHorizons],
    // checkAvailability: true,
  },
  {
    id: 1184,
    name: "Blue Lagoon",
    price: "1900 lei",
    description:
      "Buchet format din hortensii, trandafiri de tip bujor, trandafiri Avalanche, crizanteme, eustome, anthurium si gipsofila.",
    images: [blueLagoon],
  },
  {
    id: 1185,
    name: "Daisy Meadow",
    price: "1500 lei",
    description:
      "Buchet format din hortensie, dianthus, crizanteme, eustome, trandafiri, si eucalipt.",
    images: [daisyMeadow],
  },
  {
    id: 1186,
    name: "Wildflower Radiance",
    price: "1400 lei",
    description:
      "Buchet format din hortensie, crizanteme, gerbere, eustome, trandafiri de tip bujor, eucalipt si crengi decorative.",
    images: [wildflowerRadiance],
    // checkAvailability: true,
  },
  {
    id: 1187,
    name: "Sunny Posy",
    price: "1500 lei",
    description:
      "Buchet format din hortensie, floarea soarelui, crizanteme, dianthus, astromerii, hipericum, eustome, antirinium, matricaria si eucalipt.",
    images: [sunnyPosy],
    // checkAvailability: true,
  },
  {
    id: 1188,
    name: "Vibrant Delight",
    price: "1450 lei",
    description:
      "Buchet format din hortensii, eustome, trandafiri de tip bujor. dianthus si eucalipt.",
    images: [vibrantDelight],
  },
  {
    id: 1189,
    name: "Jade Oasis",
    price: "1000 lei",
    description:
      "Buchet format din hortensie, dianthus, eustome si trandafiri de tip bujor.",
    images: [jadeOasis],
  },
  {
    id: 1190,
    name: "Blue River",
    price: "450 lei",
    description: "Buchet format din hortensie si verdeata decorativa.",
    images: [blueRiver],
  },
  {
    id: 1191,
    name: "Lush Lavender",
    price: "1500 lei",
    description:
      "Buchet format din hortensie, trandafiri, anthurium si eucalipt.",
    images: [lushLavender],
  },
  {
    id: 1192,
    name: "Pink Breeze",
    price: "800 lei",
    description:
      "Buchet format din hortensie, eustome, crizanteme si scobioza.",
    images: [pinkBreeze],
  },
  {
    id: 1193,
    name: "Purple Rain",
    price: "1100 lei",
    description: "Buchet format din hortensie, trandafiri, gerbere si matiole.",
    images: [purpleRain],
  },
  {
    id: 1194,
    name: "Pure Beauty",
    price: "2300 lei",
    description:
      "Buchet delicat format din hortensii, bujori, eustome, crizanteme si matiole.",
    images: [pureBeauty],
    // checkAvailability: true,
  },
  {
    id: 1195,
    name: "Purple Pink",
    price: "1250 lei",
    description:
      "Buchet format din hortensie, trandafiri de tip bujor,matricala si verdeata decorativa.",
    images: [purplePink],
    // checkAvailability: true,
  },
  {
    id: 1196,
    name: "Hydrangea Glow",
    price: "1200 lei",
    description: "Buchet elegant format din hortensie si eucalipt.",
    images: [hydrangeaGlow],
  },
  {
    id: 1197,
    name: "Hortensia Mix",
    price: "2400 lei",
    description: "Buchet catifelat format din 7 hortensii.",
    images: [hortensiaMix],
  },
  // {
  //   id: 1164,
  //   name: "Berry Sorbet",
  //   price: "1500 lei",
  //   description:
  //     "Buchet format din hortensie, gladiole, trandafiri, eustome si eucalipt.",
  //   images: [berrySorbet],
  // },
  // {
  //   id: 1162,
  //   name: "Summer Romance",
  //   price: "800 lei",
  //   description: "Buchet format din bujori, trandafiri, si eucalipt.",
  //   images: [summerRomance],
  // },
  // {
  //   id: 1158,
  //   name: "Rainbow Glow",
  //   price: "1600 lei",
  //   description:
  //     "Buchet elegant format din hortensie, trandafiri, dianthus, delphinium, crizanteme si eucalipt.",
  //   images: [rainbowGlow],
  // },
  // {
  //   id: 1159,
  //   name: "Golden Gem",
  //   price: "1500 lei",
  //   description:
  //     "Buchet  format din hortensie, eustome,gladiole, gipsofila colorata și eucalipt.",
  //   images: [goldenGem],
  // },
  // {
  //   id: 1172,
  //   name: "Blush",
  //   price: "1450 lei",
  //   description:
  //     "Buchet format din hortensii, astromerii, bujori, trandafiri, antirinium, eucalipt si gipsofila.",
  //   images: [blush],
  // },
  // {
  //   id: 1186,
  //   name: "Daydream",
  //   price: "1600 lei",
  //   description:
  //     "Buchet format din hortensie, trandafiri, crizanteme, eustome, delphinium si gipsofila colorata.",
  //   images: [daydream],
  // },

  // {
  //   id: 98,
  //   name: "Color Pop",
  //   price: "900 lei",
  //   description:
  //     "Buchet elegant format din hortensie, eustome si verdeata decorativa.",
  //   images: [colorPop],
  // },
  // {
  //   id: 93,
  //   name: "Lilac",
  //   price: "850 lei",
  //   description:
  //     "Buchet elegant format din hortensie, trandafiri de tip bujor, crizanteme, gipsofila colorata si verdeata decorativa.",
  //   images: [lilac],
  // },

  // {
  //   id: 307,
  //   name: "Bloom In Blue",
  //   price: "1900 lei",
  //   description:
  //     "Buchet armonios format din hortensii, trandafiri Juliette, eustome si eucalipt.",
  //   images: [bloomInBlue],
  // },
  // {
  //   id: 115,
  //   name: "Euphoria",
  //   price: "1350 lei",
  //   description:
  //     "Buchet elegant format din hortensie, cale, eustome, trandafiri, crizanteme si gipsofila.",
  //   images: [euphoria],
  // },
];

export default BucheteDeVara;
